import { CancelablePromise, OpenAPI, type Response } from "@/api";
import { request as __request } from "../core/request";
import { CarouselAddRequest } from "@/api/models/carousel/CarouselAddRequest";
import { ListRequest } from "@/api/models/ListRequest";
import { CarouselListResponse } from "@/api/models/carousel/CarouselListResponse";
import { CarouselUpdateRequest } from "@/api/models/carousel/CarouselUpdateRequest";
import { ToDeleteRequest } from "@/utils/slice";

export class CarouselService {
  public static Add(body: CarouselAddRequest): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/admin/carousel",
      body: body,
    });
  }

  public static ListAll(
    body: ListRequest
  ): CancelablePromise<CarouselListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/carousel",
      body: body,
    });
  }

  public static Update(
    body: CarouselUpdateRequest
  ): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/admin/carousel",
      body: body,
    });
  }

  public static Delete(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/carousel",
      body: ToDeleteRequest(body),
    });
  }

  public static Drop(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/carousel/drop",
      body: ToDeleteRequest(body),
    });
  }
}
